import deleteExtractImage from '../../assets/images/delete-extract.png';
import cancelExtractionImage from '../../assets/images/cancel-extraction.png';
import cancelInProgressExtractionImage from '../../assets/images/cancel-inprogress-extraction.png';
import loseManualImage from '../../assets/images/lose-manual.png';
import deleteSheetImage from '../../assets/images/delete-sheet.png';
import deleteFileImage from '../../assets/images/delete-file.png';

export const deleteActions = data => {
  return {
    'delete-extract': {
      description: `Are you sure you want to delete the extraction "${data?.category}"?`,
      image: deleteExtractImage
    },
    'save-extraction': {
      description: 'Are you sure you want to save the data?'
    },
    'delete-sheet': {
      description:
        'All relevant information will be deleted including data <br/>extractions and reports',
      image: deleteSheetImage,
      title: `Are you sure you want to permanently delete ${data?.name} sheet?`
    },
    'delete-file': {
      description:
        'All relevant information will be deleted including data <br/>extractions and reports',
      image: deleteFileImage,
      title: `Are you sure you want to permanently ${data?.name} file?`
    },
    'cancel-auto-extraction': {
      description: 'Are you sure you want to cancel the extraction?',
      image: cancelExtractionImage
    },
    'cancel-in-progress-auto-extraction': {
      description: 'Auto extraction is currently in progress, do you want to cancel it?',
      image: cancelInProgressExtractionImage
    },
    'lose-manual-extraction': {
      description: 'Your changes from the manual extraction will be lost, do you want to proceed?',
      image: loseManualImage
    },
    'reset-autoextraction': {
      description:
        'Are you sure you want to re-extract the data? This will overwrite the current existing extraction.',
      image: loseManualImage
    }
  };
};

export function getMaxArray(arrays) {
  let maxArray = [];

  arrays.forEach(array => {
    if (array.length > maxArray.length) {
      maxArray = array;
    }
  });

  return maxArray;
}

export const checkIsInInterval = (start, end, val) => val > start && end >= val;

export function getUpdatedExtractedFileFunds(extractedFile, fundMappings) {
  if (!extractedFile) return null;

  const fundMappingsList = fundMappings?.fund_mappings?.filter(item => !!item.source_fund) || [];
  const fundMap = new Map(fundMappingsList.map(item => [item.input_fund.id, item.input_fund]));

  const existingFunds = extractedFile.funds || [];
  const existingFundsMap = new Map(existingFunds.map(fund => [fund.id, fund]));
  const fallbackTables = existingFunds[0]?.tables || [];

  const updatedFunds = [];

  // Add or preserve only funds present in mapping
  for (const [id, inputFund] of fundMap.entries()) {
    const existingFund = existingFundsMap.get(id);

    if (existingFund) {
      // Preserve full original object
      updatedFunds.push(existingFund);
    } else {
      // Add new fund from mapping
      updatedFunds.push({
        id,
        name: inputFund.name,
        tables: fallbackTables,
        data: {}
      });
    }
  }

  return {
    ...extractedFile,
    funds: updatedFunds
  };
}
